import axios from 'axios';

let apiUrl = 'https://api.heu.dev2.cybertest.cz/';

if(environment) {
  switch(environment) {
    case 'local':
      apiUrl = 'http://api.heu.local/';
      break;
    case 'dev':
      apiUrl = 'https://api.heu.dev2.cybertest.cz/';
      break;
    case 'uat':
      apiUrl = 'https://api.heu.uat2.cybertest.cz/';
      break;
    case 'prod':
      apiUrl = 'https://api.heu.prod2.cybertest.cz/';
      break;
    default:
      apiUrl = 'https://api.heu.dev2.cybertest.cz/';
  }
}


const locale = document.documentElement.lang

const instance = axios.create({
  baseURL: apiUrl + locale
});

const fetchItems = (url) => {
  try {
    return instance
      .get(url)
      .then((response) => {
        return response.data;
      })
  } catch (error) {
    console.log(error);
  }
}

export default fetchItems;
